export var USER_INPUT_FILTER_CONDITIONS;
(function (USER_INPUT_FILTER_CONDITIONS) {
    USER_INPUT_FILTER_CONDITIONS["EQUALS"] = "eq";
    USER_INPUT_FILTER_CONDITIONS["NOT_EQUALS"] = "ne";
    USER_INPUT_FILTER_CONDITIONS["INCLUDES_ANY"] = "includesAny";
    USER_INPUT_FILTER_CONDITIONS["EXCLUDES_ANY"] = "excludesAny";
    USER_INPUT_FILTER_CONDITIONS["INCLUDES_ALL"] = "includesAll";
    USER_INPUT_FILTER_CONDITIONS["GREATER_THAN_OR_EQUAL"] = "ge";
    USER_INPUT_FILTER_CONDITIONS["LESS_THAN_OR_EQUAL"] = "le";
    USER_INPUT_FILTER_CONDITIONS["IN_BETWEEN"] = "inBetween";
    USER_INPUT_FILTER_CONDITIONS["OUTSIDE_OF"] = "outsideOf";
})(USER_INPUT_FILTER_CONDITIONS || (USER_INPUT_FILTER_CONDITIONS = {}));
//# sourceMappingURL=bindingConfig.js.map